export default __webpack_public_path__ + "static/media/BlackCurtain3.145d055a.png";